export default "__VITE_ASSET__BmltEezF__"